import { opacity } from '../../utils';
import { colors } from '../colors';

export const label = {
  color: opacity(colors.gray[0], 50),
};
